// /src/components/Footer.jsx
import React from 'react'
import { Link } from 'react-router-dom'
import { Book, Trees, Sprout, Github, Twitter, Mail } from 'lucide-react'

const Footer = () => {
  return (
    <footer className="bg-[#dff0a5] text-forest-900">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="col-span-1 md:col-span-2">
            <div className="flex items-center mb-4">
              <img src="/logolong.png" alt="PalmGarden Logo" className="h-10 w-auto object-contain" />
            </div>
            <p className="text-forest-700 mb-4 max-w-md">
              Your comprehensive platform for plant knowledge, reforestation tracking, and seed preservation. 
              Join us in building a greener future.
            </p>
            <div className="flex space-x-4">
              <a href="#" className="text-forest-600 hover:text-forest-900 transition-colors duration-200">
                <Github className="w-5 h-5" />
              </a>
              <a href="#" className="text-forest-600 hover:text-forest-900 transition-colors duration-200">
                <Twitter className="w-5 h-5" />
              </a>
              <a href="#" className="text-forest-600 hover:text-forest-900 transition-colors duration-200">
                <Mail className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold mb-4 text-forest-900">Platform</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/wiki" className="text-forest-700 hover:text-forest-900 transition-colors duration-200">
                  PlantWiki
                </Link>
              </li>
              <li>
                <Link to="/reforestation" className="text-forest-700 hover:text-forest-900 transition-colors duration-200">
                  Reforestation
                </Link>
              </li>
              <li>
                <Link to="/seedbank" className="text-forest-700 hover:text-forest-900 transition-colors duration-200">
                  SeedBank
                </Link>
              </li>
              <li>
                <Link to="/search" className="text-forest-700 hover:text-forest-900 transition-colors duration-200">
                  Search Plants
                </Link>
              </li>
            </ul>
          </div>

          {/* Resources */}
          <div>
            <h3 className="text-lg font-semibold mb-4 text-forest-900">Resources</h3>
            <ul className="space-y-2">
              <li>
                <a href="#" className="text-forest-700 hover:text-forest-900 transition-colors duration-200">
                  Plant Care Guides
                </a>
              </li>
              <li>
                <a href="#" className="text-forest-700 hover:text-forest-900 transition-colors duration-200">
                  Reforestation Projects
                </a>
              </li>
              <li>
                <a href="#" className="text-forest-700 hover:text-forest-900 transition-colors duration-200">
                  Seed Collection
                </a>
              </li>
              <li>
                <a href="#" className="text-forest-700 hover:text-forest-900 transition-colors duration-200">
                  Community Forum
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-forest-300 mt-8 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="text-forest-600 text-sm">
              © {new Date().getFullYear()} PalmGarden. All rights reserved.
            </p>
            <div className="flex space-x-6 mt-4 md:mt-0">
              <a href="#" className="text-forest-600 hover:text-forest-900 text-sm transition-colors duration-200">
                Privacy Policy
              </a>
              <a href="#" className="text-forest-600 hover:text-forest-900 text-sm transition-colors duration-200">
                Terms of Service
              </a>
              <a href="#" className="text-forest-600 hover:text-forest-900 text-sm transition-colors duration-200">
                Contact
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer 